import { Button } from '@mui/material';
import { useContext } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { UserContext } from '../../../context';
import { UserAvatar } from '../../atoms';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 12,
    background: '#323232',
    padding: '1.5rem 30px',
    minWidth: 400,
    color: '#fff',
    boxSizing: 'border-box',
    textTransform: 'none',
    cursor: 'pointer',
    gap: '2rem',
    boxShadow: 'none', // do not use border, it causes bumpy animation

    '&:hover': {
      filter: 'brightness(1.2)',
      boxShadow: `
        0 0 12px 2px ${theme.palette.primary.main} /* glow */
      `,
    },
  },
  left: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    gap: '0.2rem',
  },
  tickets: {
    fontSize: '1.25rem',
    fontWeight: 400,
    textAlign: 'left',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '.3rem',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: '0.5rem',
  },
  name: {
    textAlign: 'left',
    fontWeight: 700,
    fontSize: '1.25rem',
  },
  account: {
    fontWeight: 400,
    fontSize: '1.1rem',
    textTransform: 'capitalize',
  },
  avatarWrapper: {
    position: 'relative',
    display: 'inline-block',
    margin: 'auto auto',
  },
}));

export interface UserBoxProps {
  openUserMenu: () => void;
}

const UserBox: React.FC<UserBoxProps> = ({ openUserMenu }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { user, numberOfTickets } = useContext(UserContext);

  const tickets = `Tickets: ${numberOfTickets}`;
  const name = `${user.firstName} ${user.lastName}`;
  const accountType = user.subscriptions.length > 0 ? t('nav.premium') : t('nav.free_account');

  return (
    <Button className={classes.root} onClick={openUserMenu}>
      <div className={classes.left}>
        <span className={classes.avatarWrapper}>
          <UserAvatar size={56} />
        </span>
        <div className={classes.userInfo}>
          <div className={classes.name}>{name}</div>
          <div className={classes.account}>{accountType}</div>
        </div>
      </div>
      <div className={classes.right}>
        <div className={classes.tickets}>{tickets}</div>
      </div>
    </Button>
  );
};

export default UserBox;
